import BaseError from './BaseError';

class ParseError extends BaseError {
  constructor(message: string, fileName?: string, lineNumber?: number) {
    super('ParseError', message, fileName, lineNumber);
  }
}

export default ParseError;
